import { createContext, useContext } from 'react'
import type { CdnSource } from '../crm/client'
import type { FanslyApi } from './api'

/**
 * What a Fansly page needs from the outside world, bound to one account: the
 * Fansly API through the CRM, and Fansly media (signed CDN URLs locked to the
 * account's proxy IP come through the CRM). Tests provide fakes.
 */
export interface FanslyDeps {
  api: FanslyApi
  /** A displayable source for an image (or a poster). */
  loadMedia: (url: string, signal?: AbortSignal) => Promise<CdnSource>
  /** A playable URL for video/audio. */
  streamMedia: (url: string) => Promise<string>
}

export const FanslyDepsContext = createContext<FanslyDeps | null>(null)

export function useFanslyDeps(): FanslyDeps {
  const deps = useContext(FanslyDepsContext)
  if (!deps) throw new Error('useFanslyDeps outside FanslyDepsProvider')
  return deps
}

export function useFanslyApi(): FanslyApi {
  return useFanslyDeps().api
}
